var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.300781,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#1F1F1F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 6.30078,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#1F1F1F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 12.3008,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.82606ab99766ac1b0bb694160c981f3e.svg";
export { ForwardRef as ReactComponent };